import script from "./TabReportDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabReportDownload.vue?vue&type=script&setup=true&lang=ts"

import "./TabReportDownload.vue?vue&type=style&index=0&id=150e2d5a&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-150e2d5a"]])

export default __exports__